import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ProductsTechnicalFeaturesComponent } from './configuration/products-technical-features/products-technical-features.component';
import { ProductsTechnicalFeaturesGroupsComponent } from './configuration/products-technical-features-groups/products-technical-features-groups.component';
import { RatesComponent } from './configuration/rates/rates.component';
import { ProductsOperativeProductsComponent } from './operative/products-operative-products/products-operative-products.component';
import { ProductsConfigurationComponent } from './configuration/products-configuration.component';
import { ProductsOperativeComponent } from './operative/products-operative.component';
import { ProductsAnalysisComponent } from './analysis/products-analysis.component';
import { NotFoundComponent } from '../not-found/not-found.component';
import { tabDirtyGuard } from 'src/app/libs/components/tabs-host/tab-dirty.guard';
import { access, saveAppUri } from 'src/app/libs/guards';
import { AppDashboardComponent } from 'src/app/libs/components/app-dashboard/app-dashboard.component';
import { ProductsBatchComponent } from './operative/products-batch/products-batch.component';
import { FormatsComponent } from './configuration/formats/formats.component';
import { ProductBatchStatesComponent } from './configuration/product-batch-states/product-batch-states.component';
import { BatchTypesComponent } from './configuration/batch-types/batch-types.component';
import { EAccessName } from 'src/app/libs/services/acl.service';

const routes: Routes = [
  {
    path: '',
    component: AppDashboardComponent,
    data: { breadcrumb: 'products' },
    children: [
      {
        path: 'operative',
        component: ProductsOperativeComponent,
        data: { breadcrumb: 'operative' },
        children: [
          {
            path: 'products',
            component: ProductsOperativeProductsComponent,
            data: { breadcrumb: 'products', access: 'products-operative' },
            canActivate: [access, saveAppUri],
            canDeactivate: [tabDirtyGuard],
          },
          {
            path: 'blockedBatches',
            component: NotFoundComponent,
            data: { breadcrumb: 'blockedBatches', access: 'products-operative' },
            canActivate: [access, saveAppUri],
            canDeactivate: [tabDirtyGuard],
          },
          {
            path: 'lots',
            component: ProductsBatchComponent,
            data: { breadcrumb: 'lots', access: 'products-operative' },
            canActivate: [access, saveAppUri],
            canDeactivate: [tabDirtyGuard],
          },
          {
            path: 'rates',
            component: RatesComponent,
            data: { breadcrumb: 'rates', access: 'products-operative' },
            canActivate: [access],
            canDeactivate: [tabDirtyGuard],
          },
          { path: '**', component: NotFoundComponent },
        ],
      },
      {
        path: 'analysis',
        component: ProductsAnalysisComponent,
        data: { breadcrumb: 'analysis' },
        children: [
          { path: '**', component: NotFoundComponent },
        ],
        canDeactivate: [tabDirtyGuard],
      },
      {
        path: 'configuration',
        component: ProductsConfigurationComponent,
        data: { breadcrumb: 'configuration' },
        children: [
          {
            path: 'technicalFeatures',
            component: ProductsTechnicalFeaturesComponent,
            data: { breadcrumb: 'technicalFeatures', access: EAccessName.EquipmentsConfiguration },
          },
          {
            path: 'technicalFeaturesGroups',
            component: ProductsTechnicalFeaturesGroupsComponent,
            data: { breadcrumb: 'technicalFeaturesGroups', access: EAccessName.EquipmentsConfiguration },
          },
          {
            path: 'formats',
            component: FormatsComponent,
            data: { breadcrumb: 'formats', access: 'products-operative' },
          },
          {
            path: 'productBatchStates',
            component: ProductBatchStatesComponent,
            data: { breadcrumb: 'productBatchStates', access: 'products-operative' },
          },
          {
            path: 'batchTypes',
            component: BatchTypesComponent,
            data: { breadcrumb: 'batchTypes', access: 'products-operative' },
          },
          { path: '**', component: NotFoundComponent },
        ],
        canDeactivate: [tabDirtyGuard],
      },
      { path: '**', component: NotFoundComponent },
    ],
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductsRoutingModule {}
